<template>
  <spinner v-if="loading" />
  <section v-if="personListViewModel && !hideAll" class="py-5">
    <header v-if="headline" class="mw-820 mx-auto px-3 text-center">
      <div v-if="label" class="h6 mb-3">{{ label }}</div>
      <h2 class="h2 mb-5" v-html="headline"></h2>
    </header>
    <div
      class="rte-text mw-820 mx-auto mb-5 text-center"
      v-html="introText"
      v-if="introText"
    ></div>
    <button-swiper
      :buttons="personListViewModel.filter.items"
      @mousedown="preventFocus"
      @clickEvent="selectItemAndSearch"
      v-if="
        personListViewModel &&
        personListViewModel.filter &&
        personListViewModel.filter.items.length > 0
      "
    />
    <div class="card-list-view" :style="cssVars">
      <div
        class="row mw-1200 mx-auto px-3"
        :data-length="resultItems.length"
        v-if="resultItems"
      >
        <div
          class="col-12 col-md-6 col-lg-4 px-1 mb-5"
          v-for="(item, index) in resultItems"
          :key="index"
          :ref="setItemRef"
        >
          <person-view-card :card="item" />
        </div>
      </div>
    </div>
    <nav
      v-if="showPagination && personListViewModel.paging.pagesInAll > 1"
      aria-label="Blog sider"
    >
      <ul class="d-flex list-unstyled justify-content-center">
        <template
          v-for="index in personListViewModel.paging.pagesInAll"
          :key="index"
        >
          <li
            aria-current="page"
            v-if="index == personListViewModel.paging.pageNumber"
          >
            <a class="btn circle-btn active">{{ index }}</a>
          </li>
          <li v-else>
            <a class="btn circle-btn" :href="renderPageLink(index)">{{
              index
            }}</a>
          </li>
        </template>
      </ul>
    </nav>
    <div
      class="d-flex justify-content-center"
      v-if="morePagesToLoad && !showPagination"
    >
      <button
        class="btn border rounded-pill"
        @mousedown="preventFocus"
        @click="getMoreResultItems()"
      >
        Indlæs flere
      </button>
    </div>
  </section>
</template>

<script>
import Spinner from "./components/Spinner.vue";
import PersonViewCard from "./components/PersonViewCard.vue";
import ButtonSwiper from "./components/ButtonSwiper.vue";

export default {
  name: "PersonListApp",
  components: {
    Spinner,
    PersonViewCard,
    ButtonSwiper,
  },
  computed: {
    morePagesToLoad() {
      return (
        this.personListViewModel.paging.pageNumber <
        this.personListViewModel.paging.pagesInAll
      );
    },
    cssVars() {
      return {
        "--before-height": this.cardImageHeight / 2 + "px",
        "--after-height":  this.lastCardHeight - this.cardImageHeight/2 + "px",
      };
    },
  },
  data() {
    return {
      loading: true,
      personListViewModel: undefined,
      sectionStyling: undefined,
      headline: undefined,
      label: undefined,
      introText: undefined,
      showPagination: undefined,
      hideIfNoResults: false,
      hideAll: false,
      resultItems: [],
      cardItemRefs: [],
      cardImageHeight: undefined,
      lastCardHeight: undefined,
      initialLoad: true
    };
  },
  mounted() {
    this.initialize();
  },
  updated() {
    if (this.initialLoad) {
      const lastCardItem = (this.cardImageHeight =
        this.cardItemRefs[this.cardItemRefs.length - 1]);
      this.lastCardHeight = lastCardItem.offsetHeight;
      this.cardImageHeight = lastCardItem.querySelector("img").offsetHeight;
      this.initialLoad = false;
    }
  },
  methods: {
    initialize() {
      const urlParameters = new URLSearchParams(
        decodeURI(window.location.search)
      );

      // Check for fiilters in url
      const urlFilter = urlParameters.getAll("persontag");
      const urlPage = urlParameters.get("page");

      // Getting filter and do initial search
      this.$store
        .dispatch("getPersonListFilter", urlFilter)
        .then((filterData) => {
          this.sectionStyling = filterData.sectionStyling;
          this.headline = filterData.headline;
          this.label = filterData.label;
          this.introText = filterData.introText;
          this.showPagination = filterData.showPagination;
          this.hideIfNoResults = filterData.hideIfNoResults;

          if (urlPage && filterData.showPagination) {
            filterData.paging.pageNumber = urlPage[0];
          }

          this.$store
            .dispatch("searchPersonList", filterData)
            .then((searchData) => {
              this.cardItemRefs = [];
              this.loading = false;
              this.personListViewModel = searchData;
              this.resultItems = searchData.result.items;
              this.hideAll = this.hideIfNoResults && !this.resultItems.length;
            });
        });
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
    setItemRef(el) {
      if (el) {
        this.cardItemRefs.push(el);
      }
    },
    renderPageLink(index) {
      const filterUrlString = this.getTagsUrlString();
      if (filterUrlString !== "" && index > 1) {
        return location.pathname + "?" + filterUrlString + "&page=" + index;
      } else if (filterUrlString !== "" && index <= 1) {
        return location.pathname + "?" + filterUrlString;
      } else if (filterUrlString === "" && index > 1) {
        return location.pathname + "?page=" + index;
      } else {
        return location.pathname;
      }
    },
    getTagsUrlString() {
      const urlParameters = new URLSearchParams(
        decodeURI(window.location.search)
      );
      const urlTags = urlParameters.getAll("persontag");
      const filter = this.personListViewModel.filter.items.find(
        (selectedFilter) => selectedFilter.isSelected
      );
      const filterUrlName =
        filter && filter.hashName !== "" ? filter.hashName : "";
      if (urlTags && filterUrlName && !urlTags.includes(filterUrlName)) {
        urlTags.push(filterUrlName);
      }
      var filterUrlString = "";
      if (urlTags && urlTags != null) {
        urlTags.forEach((urlTag) => {
          if (
            this.personListViewModel.filter.items.some(
              (item) => item.hashName === urlTag && !item.isSelected
            )
          ) {
            //Ehm :P?
          } else {
            filterUrlString = filterUrlString + "&persontag=" + urlTag;
          }
        });
      }
      return filterUrlString.replace(/^(&)/, "");
    },
    setUrl() {
      const index = this.personListViewModel.paging.pageNumber;
      const filterUrlString = this.getTagsUrlString();
      if (filterUrlString !== "" && index > 1) {
        history.replaceState(
          null,
          "",
          location.pathname + "?" + filterUrlString + "&page=" + index
        );
      } else if (filterUrlString !== "" && index <= 1) {
        history.replaceState(
          null,
          "",
          location.pathname + "?" + filterUrlString
        );
      } else if (filterUrlString === "" && index > 1) {
        history.replaceState(null, "", location.pathname + "?page=" + index);
      } else {
        history.replaceState(null, "", location.pathname);
      }
    },
    getMoreResultItems() {
      // Getting filter and do initial search

      this.personListViewModel.paging.pageNumber += 1;
      this.$store
        .dispatch("searchPersonList", this.personListViewModel)
        .then((data) => {
          this.cardItemRefs = [];
          this.personListViewModel = data;
          this.personListViewModel.result.items.forEach((element) => {
            this.resultItems.push(element);
          });
          this.initialLoad = false;
        });
    },
    selectItemAndSearch(item) {
      // if item is already selected we return
      if (item.isSelected) {
        return;
      }

      this.loading = true;

      // Deselecting rest of the items
      this.personListViewModel.filter.items.forEach(
        (x) => (x.isSelected = false)
      );

      // Select the clicked item
      item.isSelected = true;

      // Reseting to default search parameters
      this.personListViewModel.paging.pageNumber = 1;

      // searching
      this.$store
        .dispatch("searchPersonList", {
          filter: this.personListViewModel.filter,
          preFilter: this.personListViewModel.preFilter,
          paging: this.personListViewModel.paging,
        })
        .then((data) => {
          this.loading = false;
          this.cardItemRefs = [];
          this.personListViewModel = data;
          this.resultItems = data.result.items;
          this.setUrl();
        });
    },
  },
};
</script>
<style scoped>
.card-list-view {
  background: linear-gradient(
    transparent var(--before-height),
    #efeae3 var(--before-height),
    #efeae3 calc(100% - var(--after-height)),
    transparent calc(100% - var(--after-height))
  );
}
</style>